<style scoped>
.mmuul li{
  list-style: none;
  display: block;
  padding: 2px;
  cursor: pointer;
  border:1px solid #fff;
  margin-bottom: 2px;
}
.mmuul li:hover{
  border:1px solid rgba(255, 165, 0, 0.5);
}
.mmuul li.active{
  border:1px solid orange;
}
</style>

<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" :dis-hover="true" style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary"  @click="modal1=true;detail={state:'上架'}" v-if="power.indexOf(25)!=-1">增加</Button>
            <cite>|</cite>
            <Checkbox @on-change="load" v-model="houtai">按创建时间排序（最新创建在最上面）</Checkbox>
          </Col>
          <Col span="5">
             <Input search enter-button placeholder="输入主题搜索" v-model="serch.key"  @on-search="load"/>
          </Col>
        </Row>
      </div>
    </Card>

    <Card :dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="id" label="编号" width="60" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="img" label="秒杀封面图" width="230" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <img :src="'/api/upload/online/'+scope.row.img" style="width:200px;"/>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="秒杀主题" :show-tooltip-when-overflow="true">
          <template slot-scope="scope">
            <a @click="m2.modal=true;m2.mid=scope.row.id"  v-if="power.indexOf(26)!=-1">{{scope.row.title}}</a>
            <span v-else>{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nid" label="关联内训ID" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="spids" label="打包公开课" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="state" label="上架状态" width="80" :show-tooltip-when-overflow="true"></el-table-column>
<!--        <el-table-column prop="yj" label="原价" width="80" :show-tooltip-when-overflow="true"></el-table-column>-->
        <el-table-column prop="xj" label="活动价" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="qnum" label="全部名额" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="num" label="剩余名额" width="80" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ztime" label="最近场次时间" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="ctime" label="创建时间" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <a @click="getyj(scope.row.id)">查看原价</a>

            <span v-if="power.indexOf(26)!=-1">
               <cite>|</cite>
                <a @click="edit(scope.row.id)">编辑</a>
            </span>

            <span  v-if="power.indexOf(27)!=-1">
              <cite>|</cite>
              <a @click="remove(scope.row.id)">删除</a>
            </span>

          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      :mask-closable="false">
      <Form :label-width="100">
        <FormItem label="秒杀图片" required>
          <UploadOne v-model="detail.img"/>
        </FormItem>
				<FormItem label="显示标题" required>
					<Input v-model="detail.title"/>
				</FormItem>
				<FormItem label="关联内训" required>
          <Select v-model="detail.nid">
            <Option :value="item.id" :label="item.title" v-for="item in nxs"></Option>
          </Select>
				</FormItem>
				<FormItem label="打包公开课" required>
<!--          <SpSelect v-model="detail.spids"></SpSelect>-->
					<Input v-model="detail.spids" placeholder="输入关键词搜索课程" readonly/>
          <p>这里填写公开课场次编号，多个公开课用英文逗号分隔</p>
          <a @click="modal2=true">点击课程场次管理</a>
				</FormItem>
        <FormItem label="上架状态" required>
          <Select v-model="detail.state">
            <Option value="上架" label="上架"></Option>
            <Option value="下架" label="下架"></Option>
          </Select>
        </FormItem>
<!--				<FormItem label="原价" required>-->
<!--					<Input v-model="detail.yj"/>-->
<!--				</FormItem>-->
				<FormItem label="活动价" required>
					<Input v-model="detail.xj"/>
				</FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="modal2"
      title="课程场次管理"
      width="700">
      <Spselect v-model="detail.spids"></Spselect>
<!--      <Input @on-change="remoteMethod1" v-model="spname"/>-->
<!--      <div v-if="loading1">加载中...</div>-->
<!--      <ul class="mmuul" style="margin-top: 10px">-->
<!--        <li :class="{'active':detail.spid==option.SP_ID}"  @click="clickwang(option)"  v-for="option in options1"><Tag>{{option.SP_ID}}</Tag>{{option.PP_NAME}}<cite>/</cite>{{option.SP_STIME}}<cite>/</cite>{{option.SP_ADDRESS}}</li>-->
<!--      </ul>-->
    </Modal>

    <Drawer title="场次管理" v-model="m2.modal" width="800">
      <MsnxSub :mid="m2.mid"/>
    </Drawer>

  </div>
</template>

<script>
  import Spselect from "../common/Spselect";
  import MsnxSub from "./MsnxSub";
  import UploadOne from "../../public/upload/UploadOne";
  import SpSelect from './common/SpSelect'
  export default {
    components:{MsnxSub,UploadOne,SpSelect,Spselect},
    data(){
      return{
        power:this.$storage.getSession('power'),
        baseUrl:'/api/miaosha/msneixun/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        m2:{
          modal:false,
          mid:0
        },
        modal2:false,
        loading:false,
        nxs:[],//选择内训
        options1:[],
        loading1:false,
        spname:'',
        houtai:true
      }
    },
    methods:{
      getyj(id){
        let that = this;
        this.$axios.get('/api/miaosha/msneixun/getyuanjia?id='+id).then(function(rs){
          alert('原价：'+rs.data);
        });
      },
      remoteMethod1 () {
        let that = this;
        this.loading1 = true;
        this.$axios.get('/api/msgkksub/querySonproject?spname='+this.spname).then(function(rs){
          that.options1 = rs.data;
          that.loading1 = false;
        });
      },
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.title@like@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params+'&houtai='+this.houtai).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();

      let that = this;
      this.$axios.get(this.baseUrl+'getnxs').then(function(rs){
       that.nxs = rs.data;
      });

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/miaosha/MsNeixun.vue